<template>
  <v-app id="inspire">
    <!-- <v-container fluid id="mainFrame">
      <v-row>
        <v-col class="text-left" style="max-width: fit-content;">
          <IconTooltipButtonBottom
              @click="$router.push('/management')"
              icon="mdi-arrow-left"
              tooltip="Zurück"
              large
          />
        </v-col>
        <v-col style="align-self: center">
          <h3>Externe WFMS-Schnittstelle</h3>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row justify="center" class="mt-10 mx-0">
        <v-alert
            color="gray_5"
            icon="mdi-information-outline"
            border="left"
            height="100"
            style="padding-top: 36px;"
        >
          Hier könnte ein ausführlicher Infotext über das Verknüpfen der Schnittstelle stehen
        </v-alert>
      </v-row>
      <v-row class="mt-4" justify="center">
        <v-col cols="7">
          <v-card outlined class="px-8 py-6 mb-10">
            <v-row class="mx-4">
              <v-switch
                  v-model="integration.integrationState"
                  label="Externe Workflowmanagement-Schnittstelle"
                  class="mt-4"
              ></v-switch>
            </v-row>
            <v-row class="mx-4 mb-8">
              <v-form v-model="valid" ref="form" style="width:80%">
                <v-text-field
                    label="URL der Schnittstelle*"
                    :rules="rules"
                    :disabled="!integration.integrationState"
                    v-model="integration.externalURL"
                ></v-text-field>
              </v-form>
            </v-row>
          </v-card>
          <v-row justify="end">
            <v-btn @click="changeIntegrationState"  color="primary" elevation="0" class="mr-4">
              Speichern
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

    </v-container> -->
  </v-app>
</template>

<script>
  import clientService from "@/components/clientService"
  import IconTooltipButtonBottom from "@/components/common/IconTooltipButtonBottom"
export default {
  name: "clientManagement",
  components: {
    IconTooltipButtonBottom
  },

  data() {
    return {
      integration: null,
      valid: true,
      rules: [
        v => !!v || 'URL muss ausgefüllt werden',
        v => /https?:[0-9]*\/\/[\w!?/\+\-_~=;\.,*&@#$%\(\)\'\[\]]+/.test(v) || 'Keine gültige URL',
      ],
    };
  },
  computed:{
    clientId() {
      return this.$store.state.currentUser.currentClientId;
    },
  },
  mounted() {
    this.init();
  },
  methods: { 
    init() {
      clientService.getIntegrationData().then((res) => {
        this.integration = res.data
      });
    },
    changeIntegrationState(){
      if(this.$refs.form.validate()){
        this.integration = {
          clientToChangeId: this.clientId,
          externalURL: this.integration.externalURL,
	        integrationState: this.integration.integrationState
        }
        clientService.changeExternalWFMSIntegration(this.integration).then(() => {
          this.$router.push("/management");
        })
      }
    }
  },
};
</script>

<style scoped>
#mainFrame {
  overflow: visible;
}
#disabled {
  cursor: not-allowed;
  color: gray
}
#edit{
  color: var(--v-primary-base)
}
.h3, h3{
  margin: 0;
}
</style>